import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStatus } from '@core/auth/auth.model';
import { AuthProdService } from '@core/auth/auth.prod.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import {
  authCheck,
  authCheckMock,
  authCheckSuccess,
  authLogin,
  authLogout,
  authLogoutFailed,
  authLogoutSuccess
} from './auth.actions';

@Injectable()
export class AuthEffects {
  login$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authLogin),
        tap(() => this.router.navigate(['login']))
      ),
    { dispatch: false }
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authLogout),
      switchMap(() => this.authService.logout()),
      map(() => authLogoutSuccess()),
      catchError(() => of(authLogoutFailed()))
    )
  );

  authCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authCheck),
      switchMap(() => this.authService.refreshToken().pipe(map((state: AuthStatus) => authCheckSuccess(state))))
    )
  );

  authCheckMock$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authCheckMock),
      switchMap(() => this.authService.refreshToken().pipe(map((state: AuthStatus) => authCheckSuccess(state)))),
      tap(() => this.router.navigate(['']))
    )
  );

  afterLogout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authLogoutSuccess, authLogoutFailed),
        tap(() => {
          this.router.navigate(['login']);
        })
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private router: Router, private authService: AuthProdService) {}
}
